import { authHeader } from '../helpers/auth-header';
import { client } from './';

export const registeredPhonesActions = {
    fetchPhones,
};

function fetchPhones() {
    const rurl = '/admin/get_registry';    
    return client.get(rurl, { headers: authHeader() })
}
